/* eslint-disable */
/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useEffect, useState } from 'react'
import { jsx } from "@emotion/core";
import { useSelector } from 'react-redux';
import ProfileIcon from './ProfileIcon';
import { loadOutseta } from '../../Components/Outseta';
import { LinkOut } from '../../Components/LandingHeader/Feedback/icons/Icons';
import { SITE_BASE_URL } from '../../Components/common/constants';

function OutsetaProfile({ activeTab, setActiveTab, trigger = null }) {
    const {colorPicker, colorPickerDark, theme} = useSelector(state => state.theme);
    const [onMouseEnterProfile, setOnMouseEnterProfile] = useState(false);

    const OPTIONS = {
        domain: "lifetab.outseta.com",
        load: "profile"
    };

    useEffect(() => {
        if(window?.chrome?.storage){
            return;
        }

        // document.body.classList.remove('dark')
        // document.body.classList.remove('light')
        // document.body.classList.add(theme);
        // document.body.style.setProperty('--accent-color-app', colorPicker);

        loadOutseta(OPTIONS).then((response) => {
            // Initialize Outseta with your access token
            response.setAccessToken(localStorage.getItem('token'));
            
            if(trigger === 'profile'){
                window.onload = () => {
                    document.getElementById('outseta-profile-link').click();
                };
            }
        });
    }, [])

    // useEffect(() => {
    //     document.body.classList.remove('dark')
    //     document.body.classList.remove('light')
    //     document.body.classList.add(theme);
    // }, [theme])

    const checkIfProcessed = (e) => {
        if(window?.chrome?.storage){
            return true;
        }else{
            if(e.target.getAttribute('o-processed') === '1') {
                return true;
            }
        }

        e.preventDefault();
        e.stopPropagation();
    }
 
    return (
        <>
            <li className={`li-setting-tab profile ${activeTab == "profile" ? 'active' : ''}`}
            css={{
                '&:hover .accordion-title':{
                    color:((theme == "dark" && colorPickerDark == "#ef233c")) ? "white !important" : (theme == "dark" && colorPickerDark == "#f8961e") ? "black !important" : (theme == "dark" && colorPickerDark == "#ffca3a") ? "black !important" : (theme == "dark" && colorPickerDark == "#27cb9a") ? "black !important" : (theme == "dark" && colorPickerDark == "#4cc9f0") ? "black !important" : "white !important"
                }
            }}
            >
                <a onClick={checkIfProcessed} id="outseta-profile-link" href={window?.chrome?.storage ? `${SITE_BASE_URL}/settings#profile` : "https://lifetab.outseta.com/profile?#o-authenticated"} target='_blank' className="settings-accordion-tab dark:bg-black" 
                    css={{
                        background: activeTab == "profile" ? (theme == 'dark' ? `linear-gradient(0deg,var(--accent-color-10),var(--accent-color-10)),#000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important`) : '',

                        '&:hover':{
                        background: theme == 'dark' ? `linear-gradient(0deg, var(--accent-color-10), var(--accent-color-10)), #000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), var(--theme-mode-color-white) !important`
                    }
                }}>
                    <div className="settings-accordion-heading">
                        <figure className="settings-icon">
                            <img src="images/profile-account.svg" className="img-default dark:invert-color" />
                        </figure>
                        <h3 className="accordion-title uppercase text-black dark:text-white">profile &amp; billing</h3>
                        <figure className="settings-icon absolute right-10 w-5 h-5">
                            <LinkOut className={"img-default stroke-black dark:stroke-white"} />
                        </figure>
                    </div>
                </a>
            </li>
        </>
    )
}

export default OutsetaProfile